import i18n from 'i18next';

import { registerValidator } from 'core/forms';

const isPositiveNumber = ({ fieldValue, validator }) => {
  const numeric = Number(fieldValue);
  return {
    hasError: fieldValue != null && (Number.isNaN(numeric) || numeric <= 0),
    error: i18n.t('error-not-positive-number'),
    isRequired: validator?.isRequired,
  };
};

registerValidator('isPositiveNumber', isPositiveNumber);

export default isPositiveNumber;
